<template>
  <div class="container">
    <!-- <div class="people-info">
      <div class="title">收货人信息</div>
      <div
        class="info c-pointer"
        v-for="(item, index) in 1"
        @click="selectPelope(index)"
        :class="index == selectIndex ? 'active' : ''"
        :key="index"
      >
        <div class="name">{{verifyList.name}}</div>
        <div class="tel">{{verifyList.mobile}}</div> -->
        <!-- <div class="address">{{verifyList.address}}</div> -->
      <!-- </div>
    </div> -->
    <div class="goods-list">
      <div class="title">商品列表  <span @click="backCart">返回购物车</span>  </div>
      <div class="goods-container">
        <div class="goods-title">
          <span class="span1">商品信息</span>
          <span class="span2">小计 (元)</span>
          <span class="span3">数量</span>
          <span class="span4">单价 (元)</span>
        </div>
        <div class="goods-info">
          <div class="goods-item-container" v-for="item in verifyList.items">
            <div class="goods-item">
              <div class="goods-img">
                <img v-lazy="item.image ? item.image :$defaultImg " alt="img" />
              </div>
              <div class="goods-base-info">
                <div class="goods-name">{{item.name}}</div>
                <div class="goods-desc">
                  <p>规格：{{item.specification}}</p>
                  <p>{{item.manufacturer}}</p>
                </div>
              </div>
              <div class="goods-price">
                <p>￥{{ item.priceStr}}</p>
                <p class="hx" v-if="item.goodsActivityInfo.activity">￥{{ item.goodsPriceStr}}</p>
              </div>
              <div class="goods-num">{{item.quantity}}</div>
              <div class="goods-subtotal">
                <p>￥{{ item.totalAmount.toFixed(2) }}</p>
              </div>
            </div>
            <div class="meal-container" >
              <div class="meal-item" v-for="i in item.goodses">
                <div class="meal-img">
                  <img v-lazy="i.image ? i.image : $defaultImg" alt="" />
                </div>
                <div class="meal-info">
                  <div class="meal-name">{{i.name}}</div>
                  <div class="meal-desc">
                    <p>{{i.manufacturer}}</p>
                  </div>
                </div>
                <div class="meal-num">× {{i.quantity}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
        <div class="pay-method">
      <div class="title">支付方式</div>
      <div class="pay-container">
        <div class="pay-item" v-for="(item,index) in payMethods" @click="selectPay(index,item)"   :key="index"
          :class="index == selectPayIndex ? 'active' : ''"
        >
          <img v-lazy="item.icon" alt="">
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
       <div class="remarks" >
         <textarea  v-model="remarks" placeholder="请填写备注信息" ></textarea>
         
      </div>
    </div>
    <div class="put-order">
     
      <div class="goods-base-price">
        <span class="span1">商品合计金额</span>
        <span class="span2">￥{{verifyList.goodsAmountStr}}</span>
      </div>
      <div class="goods-base-price express-price" v-if="verifyList.freightAmount > 0">
        <span class="span1">运费</span>
        <span class="span2">￥-{{verifyList.freightAmount==0?verifyList.freightAmount.toFixed(2):0.00}}</span>
        <!-- <i
          @click="expressFold = !expressFold"
          :class="expressFold ? 'fold' : 'no-fold'"
        ></i>
        <div class="express-coupon span2" v-show="!expressFold">123</div> -->
      </div>
      <div class="goods-base-price pre-price">
        <span class="span1">优惠合计金额</span>
        <span class="span2">￥-{{verifyList.couponAmountStr}}</span>
        <i
          @click="preFold = !preFold"
          :class="preFold ? 'fold' : 'no-fold'"
        ></i>
        <div class="pre-coupon " v-show="!preFold && verifyList.couponCombinationAmount>0">
           <span class="span1">套餐优惠</span>
           <span class="span2">￥-{{verifyList.couponCombinationAmount}}</span>
        </div>
          <div class="pre-coupon " v-show="!preFold && verifyList.couponDiscountAmount>0">
           <span class="span1">折扣优惠</span>
           <span class="span2">￥-{{verifyList.couponDiscountAmount}}</span>
        </div>
           <div class="pre-coupon " v-show="!preFold && verifyList.fullreduceAmount>0">
           <span class="span1">满减/优惠券</span>
           <span class="span2">￥-{{verifyList.fullreduceAmount}}</span>
        </div>
           <div class="pre-coupon " v-show="!preFold && verifyList.couponSpecialAmount>0">
           <span class="span1">特价优惠</span>
           <span class="span2">￥-{{verifyList.couponSpecialAmount}}</span>
        </div>
          <div class="pre-coupon " v-show="!preFold && verifyList.couponReduceAmount>0">
           <span class="span1">满送优惠</span>
           <span class="span2">￥-{{verifyList.couponReduceAmount}}</span>
        </div>
      </div>
      <div class="submit">
        <span class="span1">应付款金额</span>
        <span class="span2">￥{{verifyList.totalAmountStr}}</span>
        <span class="span3" @click="toPay">提交订单</span>
      </div>
    </div>
     <popup
      class="popup-info"
      width="400px"
      height="200px"
      @close="close"
      v-if="show"
    >
        <div class="title">是否确认货到付款订单</div>
        <div class="btn">
          <span class="span1" @click="Confirm">确定</span>
          <span class="span2" @click="close">取消</span>
        </div>
    </popup>
  <toast ref="toast"></toast>
  <a href target="_blank" ref="href" style="display:none"></a>
  </div>
</template>
<script>
export default {
  data() {
    return {
      expressFold: true,
      preFold: false,
      verifyList:'',
      selectIndex:0,
      selectPayIndex:0,
      message:'',
      submitAjax:false,
      remarks:'',
         payMethods: [
         { title: "货到付款", icon: require("@/assets/images/icon_goods1.png") },
        { title: "线上支付", icon: require("@/assets/images/icon_slfdjsk.png") },
       
      ],
        show:false
    };
  },
  created(){
    this.init()
  },
  methods: {
    selectPelope(index) {
      this.selectIndex = index;
    },
       selectPay(index,item) {
      this.selectPayIndex = index;
    },
    init(){
      let type = this.$route.query.type;
      let info = {
        id:this.$route.query.id||'',
        orderSubmitType : type?(type==1?'goods':"combination"):'cart',
        quantity:type?this.$route.query.quantity:'',
        cartItemIds:!type?this.$route.query.cartItemIds:'',
        source:'web',
        remark:this.remarks
      }
      this.info = info
      this.getData(info)

    },
    getData(info){
      let data=''
      if(this.$route.query.data){
          data = JSON.parse(this.$route.query.data)
      }
      if(data!=''){
         this.verifyList =data
      }
      else{
         this.$api.POST_OREDERPRE(info).then(res=>{
        if(res.status){
          this.verifyList = res.data
        }else{
          this.$router.push({path:'/cart/cartlist'})
        }
      })
      }

      
    },
    toPay() {
      
      if(this.verifyList.isTypeinComments){
        if(!this.remarks.trim()){
            this.$refs.toast.info = {
                title:'请填写订单备注',
                type:'fail'
            }
            this.$refs.toast.isShow()
          return
        }
      }
     

     if(this.selectPayIndex == 0){
       this.show = true
       return

     }
     else{

       if (!this.submitAjax) {

            this.submitAjax = true //发送请求中
          this.$api.POST_ORDERSUBMIT({...this.info,remark:this.remarks}).then(res=>{
            this.submitAjax = false //请求结束
            
            if(res.status){
              // let link = window.open('','_blank');
            let data = encodeURIComponent(JSON.stringify(res.data))

            let routeData = this.$router.resolve({
              path: "/cart/pay",
              query:{
                sn:res.data.sn,
                amount:res.data.amountStr,
                orderId:res.data.orderId
              }
            });
              this.$router.go(-1)

            //  link.location.href = routeData.href;
            this.$refs.href.href = routeData.href;
            this.$refs.href.click()
            }
            else{
              this.$refs.toast.info = {
                    title:res.message,
                    type:'fail'
                  }
                  this.$refs.toast.isShow()

            }
          })
       }


     }
      
     
     
    },
    backCart(){
      this.$router.push('/cart/cartlist')
    },
      close(){
     this.show = false
    },
  async  Confirm(){
      let sn
    await this.$api.POST_ORDERSUBMIT({...this.info,remark:this.remarks}).then(res=>{
         if(res.status){
            sn =  res.data.sn
            this.$api.POST_ORDERCOD({   //货到付款
                  sn
            }).then(res=>{
              if(res.status){
                this.$router.push({path:'/person/orderdetail',query:{type:2,sn:sn}})
              }
            })
         }
       })

    }
  },
};
</script>
<style lang="scss" scoped>
.people-info {
  border-radius: 4px;
  height: 214px;
  padding: 24px 0 0 22px;
  background: #fafafa;
  border: 1px solid #f5f5f5;
  margin-bottom: 20px;
  .title {
    font-size: 16px;
    color: #505050;
    margin-bottom: 18px;
  }
  .info {
    overflow: hidden;
    border-radius: 4px;
    width: 240px;
    padding: 20px;
    margin-right: 20px;
    border: 2px solid #f5f5f5;
    float: left;
    position: relative;
    .name {
      color: #fa4b4b;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 14px;
    }
    .tel {
      font-size: 13px;
      color: #505050;
      margin-bottom: 12px;
    }
    .address {
      font-size: 13px;
      color: #808080;
    }
  }
  .active {
    border: 2px solid #fa4b4b;
    &::after {
      content: "";
      position: absolute;
      right: -1px;
      bottom: -1px;
      width: 20px;
      height: 20px;
      background: url("../../../assets/images/icon_selected.png") no-repeat;
    }
  }
}
.goods-list {
  border-radius: 4px;

  margin-bottom: 50px;
  .title {
    position: relative;
    padding-left: 20px;
    font-size: 16px;
    color: #505050;
    height: 58px;
    line-height: 58px;
    background: #fafafa;
    span{
      position: absolute;
      right:26px ;
      font-size: 14px;
      color: #505050;
      cursor: pointer;
    }
  }
  .goods-container {
    .goods-title {
      color: #808080;
      font-size: 14px;
      padding-left: 20px;
      background: #f2f3f5;
      height: 45px;
      line-height: 45px;
      .span2 {
        float: right;
        margin-right: 30px;
      }
      .span3 {
        float: right;
        margin-right: 130px;
      }
      .span4 {
        float: right;
        margin-right: 130px;
      }
    }
    .goods-info {
    }
  }
}

.goods-item {
  font-size: 14px;
  height: 140px;
  align-items: center;
  display: flex;
  .goods-img {
    margin-right: 28px;
    img {
      width: 116px;
      height: 116px;
    }
  }
  .goods-base-info {
    width: 240px;
    height: 100%;
    margin-right: 345px;
    .goods-name {
      margin-top: 24px;
      color: #505050;
      margin-bottom: 28px;
    }
    .goods-desc {
      color: #999999;
      font-size: 12px;
      line-height: 16px;
    }
  }
  .goods-price {
    width: 90px;
    text-align: center;
    margin-right: 72px;
    p {
      color: #222222;
      font-weight: 600;
    }
    .hx {
      font-weight: 100;
      color: #999999;
      font-size: 13px;
      margin-top: 8px;
    }
  }
  .goods-num {
    text-align: center;
    width: 112px;
    margin-right: 10px;
  }
  .goods-subtotal {
    width: 130px;
    text-align: right;
    color: #fa4b4b;
    font-weight: 600;
    margin-right: 10px;
  }
  .goods-event {
    width: 90px;
    color: #666666;
    text-align: center;
  }
}
  .remarks{
    // height: 50px;
    // border: 1px solid #f5f5f5;
    // line-height: 50px;
    // padding-left: 20px;
    textarea{
      width: 100% !important;
      height: 60px;
      border: 1px solid #f5f5f5;
      resize: none;
      padding: 20px;
      outline-color:#f5f5f5 !important;

    }
  }
.put-order {
  margin-bottom: 56px;
  padding-top: 30px;
  padding-bottom: 20px;
  color: #505050;
  font-size: 14px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  min-height: 214px;
  background: #fafafa;

  .goods-base-price {
    text-align: right;
    margin-bottom: 22px;
    position: relative;
    .span1 {
      position: absolute;
      right: 150px;
    }
    .span2 {
      margin-right: 52px;
    }
  }
  .express-price,
  .pre-price {
    position: relative;
    i {
      position: absolute;
      top: 4px;
      right: 28px;
      cursor: pointer;
      width: 10px;
      height: 10px;
    }
    .fold {
      background: url("../../../assets/images/icon_p1.png") no-repeat;
    }
    .no-fold {
      background: url("../../../assets/images/icon_p2.png") no-repeat;
    }
  }

  .submit {
    text-align: right;
    .span1 {
      margin-right: 10px;
      color: #505050;
      font-size: 20px;
    }
    .span2 {
      margin-right: 20px;
      font-size: 26px;
      color: #fa4b4b;
      font-weight: 600;
    }
    .span3 {
      cursor: pointer;
      display: inline-block;
      width: 172px;
      height: 56px;
      color: #ffffff;
      font-weight: 600;
      border-radius: 2px;
      font-size: 18px;
      background: #fa4b4b;
      line-height: 56px;
      text-align: center;
      margin-right: 30px;
    }
  }
}
.meal-container {
  padding-right: 20px;
  flex-wrap: wrap;
  .meal-item {
    background: #fafafa;
    position: relative;
    height: 114px;
    width: 1155px;
    align-items: center;
    display: flex;
    padding: 28px 0 20px 40px;
    .meal-img {
      margin-right: 16px;
      img {
        width: 64px;
        height: 64px;
      }
    }
    .meal-info{
      height: 100%;
      .meal-name{
        margin-top: 8px;
        margin-bottom: 24px;
        font-size: 14px;
        color: #505050;
      }
      .meal-desc{
        color: #999999;
        font-size: 12px;
      }
    }
    .meal-num{
      position: absolute;
      right: 40px;
      font-size: 16px;
      color: #505050;
      font-weight: 600;
    }
  }
}
.goods-item-container{
  padding: 20px 0 20px 20px;
  margin-bottom: 20px;
    border: 1px solid #f5f5f5;
}
.pay-method {
  height: 188px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
      margin-bottom: 20px;
  .title {
    border-bottom: 1px solid #f5f5f5;
    padding-left: 24px;
    line-height: 58px;
    font-size: 16px;
    color: #505050;
    height: 58px;
    background: #fafafa;
  }
  .pay-container {
    padding: 32px 0 0 24px;
    .pay-item {
      position: relative;
      cursor: pointer;
      height: 68px;
      width: 188px;
      border-radius: 4px;
      border: 2px solid #fafafa;
      font-size: 16px;
      color: #3f3f4d;
      margin-right: 22px;
      float: left;
      @include flex-c;
      img {
        margin-right: 10px;
      }
    }
    .active {
      border: 2px solid #fa4b4b;
      &::after {
        content: "";
        position: absolute;
        right: -1px;
        bottom: -1px;
        width: 20px;
        height: 20px;
        background: url("../../../assets/images/icon_selected.png") no-repeat;
      }
    }
  }
}
.popup-info {
  .title {
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    margin-top: 60px;
    text-align: center;
    margin-bottom: 38px;
  }
  .btn {
    text-align: center;
    span {
      @include btn(124px, 44px, #fa4b4b, #ffffff, 16px, 2px);
    }
    .span2 {
      border: 1px solid #fa4b4b;
      color: #fa4b4b;
      background: none;
      margin-left: 20px;
    }
  }
}
.pre-coupon{
      font-size: 12px;
    color: #f56c6c;
    line-height: 16px;

}
</style>


// WEBPACK FOOTER //
// src/pages/cart/components/cart-verify.vue